import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "otometro" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", {
    id: "confetti-animation",
    class: "otometro__confetti-container"
}, null, -1);
const _hoisted_3 = ["data-level"];
const _hoisted_4 = {
    key: 1,
    class: "otometro__bar"
};
const _hoisted_5 = { class: "otometro__info" };
const _hoisted_6 = { class: "otometro__title" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_9 = {
    key: 0,
    class: "otometro__potential--error"
};
const _hoisted_10 = {
    key: 1,
    class: "otometro__potential"
};
const _hoisted_11 = {
    key: 2,
    class: "otometro__potential"
};
const _hoisted_12 = { class: "otometro__score" };
const _hoisted_13 = {
    key: 3,
    class: "otometro__potential"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "otometro__score" }, "-", -1);
const _hoisted_15 = [
    _hoisted_14
];
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import Lottie from 'lottie-web';
import i18n from '@/i18n';
import confettiData from '@/assets/json/confetti.json';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Otometro',
    props: {
        loading: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const routesBaseAudiences = ['AudienceCreateNew', 'AudienceDuplicateNew'];
        const getRoute = computed(() => {
            return String(router.currentRoute.value.name);
        });
        const score = computed(() => routesBaseAudiences.includes(getRoute.value)
            ? store.getters['audienceManager/getCount'].score
            : store.state.audience.score);
        const error = computed(() => routesBaseAudiences.includes(getRoute.value)
            ? store.getters['audienceManager/getCount'].error
            : store.state.audience.errorCount);
        const level = ref('empty');
        const levelName = computed(() => {
            const labels = {
                high: i18n.global.t('audiences.otometro.level.high'),
                medium: i18n.global.t('audiences.otometro.level.medium'),
                low: i18n.global.t('audiences.otometro.level.low'),
            };
            return labels[level.value] || '-';
        });
        const levelClass = computed(() => {
            const levelClasses = {
                high: 'otometro__level--high',
                medium: 'otometro__level--medium',
                low: 'otometro__level--low',
            };
            return levelClasses[level.value] || '';
        });
        const getSquareStyle = (index) => {
            const colors = {
                base: {
                    high: '#2ecc71',
                    medium: '#f1c40f',
                    low: '#e74c3c',
                    empty: '#eeeeee',
                },
                background: {
                    high: '#C8FADD',
                    medium: '#FFF4C7',
                    low: '#FFBAB2',
                    empty: '#eeeeee',
                },
            };
            const { base, background } = colors;
            if (score.value !== null) {
                const filledPercentage = Math.min(Math.max(score.value - index, 0), 1) * 100;
                return {
                    background: `linear-gradient(to top, ${base[level.value]} ${filledPercentage}%, ${background[level.value]} ${filledPercentage}%)`,
                };
            }
            return {
                backgroundColor: base.empty,
            };
        };
        const updatePotential = () => {
            if (score.value === null) {
                level.value = 'empty';
                return;
            }
            const high = 4.0;
            const medium = 2.5;
            if (score.value > high) {
                level.value = 'high';
            }
            else if (score.value > medium) {
                level.value = 'medium';
            }
            else {
                level.value = 'low';
            }
        };
        const shouldShowConfetti = previousStatus => {
            const isStatusHigh = level.value === 'high';
            const wasStatusNotHigh = previousStatus !== 'high';
            return isStatusHigh && wasStatusNotHigh && !props.loading;
        };
        const resetConfettiContainer = () => {
            const animationContainer = document.getElementById('confetti-animation');
            if (animationContainer) {
                animationContainer.style.display = 'block';
                animationContainer.innerHTML = '';
            }
        };
        const startConfettiAnimation = () => {
            resetConfettiContainer();
            Lottie.loadAnimation({
                container: document.getElementById('confetti-animation'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: confettiData,
            });
            const animationDuration = 2000;
            setTimeout(() => {
                const animationContainer = document.getElementById('confetti-animation');
                if (animationContainer) {
                    animationContainer.style.display = 'none';
                }
            }, animationDuration);
        };
        watch(() => props.loading, newLoadingCount => {
            const previousStatus = level.value;
            updatePotential();
            if (!newLoadingCount && shouldShowConfetti(previousStatus)) {
                startConfettiAnimation();
            }
        });
        watch(score, () => {
            updatePotential();
        }, { immediate: true, deep: true });
        return (_ctx, _cache) => {
            const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "otometro__bar",
                            "data-level": level.value
                        }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (_, index) => {
                                return _createElementVNode("div", {
                                    key: index,
                                    class: "otometro__bar--square",
                                    style: _normalizeStyle(getSquareStyle(index))
                                }, null, 4);
                            }), 64))
                        ], 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_el_skeleton, {
                                loading: true,
                                animated: "",
                                class: "otometro__bar__loading"
                            }, {
                                template: _withCtx(() => [
                                    _createVNode(_component_el_skeleton_item, {
                                        variant: "p",
                                        style: { "width": "50px", "height": "20px" }
                                    })
                                ]),
                                _: 1
                            })
                        ])),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.$t('audiences.otometro.title')) + " ", 1),
                            _createVNode(_component_el_popover, {
                                effect: "dark",
                                trigger: "hover",
                                placement: "top",
                                width: 430
                            }, {
                                reference: _withCtx(() => [
                                    _hoisted_8
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: _ctx.$t('audiences.otometro.tooltips.potential'),
                                        class: "otometro__tooltip__content"
                                    }, null, 8, _hoisted_7)
                                ]),
                                _: 1
                            })
                        ]),
                        (!_ctx.loading && error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('_error-message')), 1)
                            ]))
                            : (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_component_el_skeleton, {
                                        loading: true,
                                        animated: "",
                                        class: "otometro__potential__loading"
                                    }, {
                                        template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                style: { "height": "20px", "width": "110px" }
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : (score.value !== null && !_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, [
                                            _createElementVNode("b", null, _toDisplayString(score.value?.toFixed(2)), 1),
                                            _createTextVNode("/5.00 ")
                                        ]),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["otometro__level", levelClass.value])
                                        }, _toDisplayString(levelName.value), 3)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                    ])
                ])
            ]));
        };
    }
});
